/* global axios */
import ApiClient from '../ApiClient';

class WgptOnboardingAPI extends ApiClient {
  constructor() {
    super('onboarding', { accountScoped: true, wgpt: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get(accountId) {
    return axios.get(`/wgpt/api/v1/accounts/${accountId}/onboarding`);
  }

  delete() {
    return axios.patch(`${this.url}/complete`);
  }
}

export default new WgptOnboardingAPI();
